export enum GuidePageTitles {
  About = 'DMM競輪とは？',
  Flow = 'ご利用のながれ',
  Toreta = 'toreta+ とは？',
  Wallet = '入金/払戻金 残高とは？',
  Voting = '投票方法',
  RaceCard = '出走表の見方',
}
